import { useState } from 'react';
import { Container } from 'react-bootstrap';
import { ControlButtons } from '../ControlButtons';
import { UploadRepeater } from './UploadRepeater';

export const ATFAdditional = ({
	currAttachments = { attachments: [{ file: {} }], answer: null },
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
}) => {
	const [currFiles, setCurrFiles] = useState(currAttachments.attachments);
	const [currAnswer, setCurrAnswer] = useState(currAttachments.answer);

	const checkToDisableNext = () => {
		return (
			currAnswer === null ||
			(currAnswer === true &&
			currFiles.reduce((acc, file) => {
				if (acc === true && !file.name) {
					acc = false;
				}
				return acc;
			}, true) === false
				? true
				: false)
		);
	};

	return (
		<>
			<Container className="component mt-5">
				<h2>Do you have additional ATF attachments to add?</h2>
				<p>
					Additional attachments could include ATF listed responsible parties,
					ATF employee possessors, or other user permits.
				</p>
				<UploadRepeater
					attachments={currFiles}
					setAttachments={setCurrFiles}
					answer={currAnswer}
					setAnswer={setCurrAnswer}
				/>
			</Container>
			<Container>
				<ControlButtons
					onNext={() => onNext({ answer: currAnswer, attachments: currFiles })}
					onPrev={onPrevious}
					finalStep={finalStep}
					disableNext={checkToDisableNext()}
					disablePrev={disablePrev}
				/>
			</Container>
		</>
	);
};
